module.exports = __webpack_public_path__ + "static/project-ytmusic-ad71c9e4dea1e3fc28cb96e33d327214.png";